// API client para "mis tareas" del tecnico (vista movil "lo que me toca").
// Consume GET /order/specialist/tareas: tareas con fecha planas de TODAS las
// ODT activas del tenant (no solo las del tecnico), no ocultas, tenant-scoped.
// El frontend filtra por defecto a las del tecnico autenticado usando
// assigned_to_user_id / order_assigned_to_user_id (ver services/misTareas.js
// `esMiTarea`).
//
// Sigue el patron de src/api/hallazgoFlujo.js: fetch + getAccessTokenApi +
// manejo de errores homogeneo.
import { getAccessTokenApi } from './auth';
import { BASE_PATH_SERVER } from './config';

/**
 * @typedef {Object} Tarea
 * @property {number} id
 * @property {number} id_order
 * @property {string} description
 * @property {string|null} planned_start
 * @property {string|null} planned_end
 * @property {boolean} finish
 * @property {number} status_id
 * @property {string=} order_address
 * @property {number|null} assigned_to_user_id - Responsable de la tarea (order_item.assigned_to_user_id).
 * @property {number|null} order_assigned_to_user_id - Responsable de la ODT (order.assigned_to_user_id).
 * @property {string|null} assigned_to_nombre - fullname del responsable de la tarea, null si no tiene.
 */

/**
 * Lista plana de las tareas con fecha de todas las ODT activas del tenant.
 * @returns {Promise<Tarea[]>}
 */
export const getMisTareasApi = async () => {
  try {
    const res = await fetch(`${BASE_PATH_SERVER}order/specialist/tareas`, {
      method: 'GET',
      headers: { Authorization: getAccessTokenApi() },
    });
    return await res.json();
  } catch (err) {
    return {
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err?.message ?? 'Error desconocido',
    };
  }
};
